import axios from 'axios';

// Função para realizar a requisição de login
export const PostLoginRequest = async (username, password) => {
  try {
    const response = await axios.post(`https://app.eliandroalimentos.com.br/api/primeiro_acesso/loginrua`, {  //login001
      usuario: username, 
      senha: password 
    });
    
    // Retorna a resposta da API, ou seja, dados do login
    return response;
  } catch (err) {
    throw err; // Lançar o erro para que o componente o trate
  }
};
